import "./App.css";
import HomePage from "./Pages/HomePage";
console.clear();
function App() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

export default App;
